import React, { useContext } from 'react'
import { EngagementLetterContext } from './EngagementLetter'
import { Stack, TextField, Typography } from '@mui/material'

const FailureToDeliver = () => {
  const { engagementLetter, setEngagementLetter } = useContext(
    EngagementLetterContext
  )

  return (
    <Stack>
      <Typography variant="title3">Failure to Deliver</Typography>
      <Typography variant="caption">
        Assurance if Medical Provider unable to provide agreed cover.
      </Typography>
      <TextField
        value={engagementLetter.failureToDeliver}
        onChange={(e) =>
          setEngagementLetter((prev) => ({
            ...prev,
            failureToDeliver: e.target.value,
          }))
        }
        minRows={2}
        multiline
      />
    </Stack>
  )
}

export default FailureToDeliver